// GENERATED FILE - DO NOT MODIFY

export enum GetTeamsSortColumnDto {
    Name = "Name",
    NumberOfMembers = "NumberOfMembers",
}